import { useEffect, useState } from "react";
import "./PartTimeControlsDialog.css";
import { getPartTimeControls } from "../../Services/PartsService";
import TimeControls from "../../../../components/TimeControls/TimeControls";
import { Tag } from "../../../../components/Tags/Tag";
import ImagePlaceholder from "../../../../components/Placeholders/ImagePlaceholder";
import timePlaceholder from "../../../../assets/Images/wait.png";

const PartTimeControlsDialog = ({ timeControlsDetails, onClose }) => {
  const [timeControls, setTimeControls] = useState([]);

  useEffect(() => {
    setTimeControls(timeControlsDetails);
  }, [timeControlsDetails]);

  return (
    <div className="part-time-controls-dialog-component">
      <div className="header">
        <b>Time Controls</b>
        <button onClick={onClose} className="outlined icon">
          <i className="icon-cross"></i>
        </button>
      </div>
      {timeControls?.length > 0 ? (
        timeControls.map((timeControl) => (
          <TimeControls
            note={
              timeControl.controls.some((control) => control.remaining <= 0) ? (
                <Tag
                  tag="Overdue"
                  type="error"
                  aspect="transparent"
                  size="small"
                />
              ) : (
                ""
              )
            }
            showAsKeyValue={timeControl.short_name === "TSN"}
            isDate={timeControl.short_name === "SHELF"}
            key={timeControl.name}
            controls={timeControl.controls}
            name={timeControl.name}
            short_name={timeControl.short_name}
          />
        ))
      ) : (
        <ImagePlaceholder
          image={timePlaceholder}
          title={"No time controls available for this part"}
          subtitle={
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean consectetur magna sem, sed ultricies nulla euismod sit amet."
          }
        />
      )}
    </div>
  );
};

export default PartTimeControlsDialog;
